import { ENTERPRISE_PARTNER_ID } from '@brighte/enterprise-common/constants';
import { css } from '@emotion/react';
import { Stack } from '@spark-web/stack';
import { useOptimisticSearchParams } from 'nuqs/adapters/react-router/v7';
import { Outlet } from 'react-router';

import { Header } from '~/components/header';
import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { OutletContextType } from '~/types/marketplace';

function VendorsListLayout() {
  const searchParams = useOptimisticSearchParams();

  const channel = searchParams.get('channel');
  const leadId = searchParams.get('leadId');
  const postcode = searchParams.get('postcode');
  const categories = searchParams.get('categories')?.split(',') ?? [];
  const promotions = searchParams.get('promotions')?.split(',') ?? [];
  const suburb = searchParams.get('suburb');
  const synthetic = searchParams.get('synthetic');

  const config = usePartnerConfig();
  const partner = config?.id ?? ENTERPRISE_PARTNER_ID.brighte;

  const activeChannel = config?.configuration?.channels?.find((c) => c.slug === channel);
  const showTitle = activeChannel?.showTitleInMarketplace;

  const context: OutletContextType = {
    channel,
    partner,
    leadId,
    postcode,
    categories,
    promotions,
    suburb,
    searchParams,
    synthetic,
  };

  return (
    <>
      <Header partner={partner} channel={channel} showTitle={showTitle} />
      <Stack as="main" paddingTop="small" tabIndex={-1} css={css({ height: '90vh' })}>
        <Outlet context={context} />
      </Stack>
    </>
  );
}

export default VendorsListLayout;
